import React from 'react';
import { ShieldCheckIcon, TerminalIcon, CheckIcon, TargetIcon, MessageSquareIcon, CalendarIcon, ZapIcon, ShieldIcon, ArrowRightIcon } from 'lucide-react';
interface CTASectionProps {
  bump1: boolean;
  setBump1: (v: boolean) => void;
  bump2: boolean;
  setBump2: (v: boolean) => void;
  totalPrice: number;
  originalPrice: number;
  getCartUrl: () => string;
  handlePurchaseClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export function CTASection({
  bump1,
  setBump1,
  bump2,
  setBump2,
  totalPrice,
  originalPrice,
  getCartUrl,
  handlePurchaseClick
}: CTASectionProps) {
  return <section id="checkout" className="pt-2 pb-8 relative overflow-hidden" data-id="element-289">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-290"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-291">
        <div className="text-center mb-5" data-id="element-292">
          <TerminalIcon className="w-12 h-12 text-cyan-400 mx-auto mb-3" data-id="element-293" />
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-2" data-id="element-294">
            Enter The New Elite
          </h2>
          <p className="text-xl text-gray-300 mb-3" data-id="element-295">
            As an Architect of the $10k Engine, you no longer trade your health
            for a paycheck. You no longer worry about "AI taking your job"
            because you are the one pulling the levers of the machine.
          </p>
          <p className="text-2xl font-bold text-cyan-400 text-glow mb-5" data-id="element-296">
            Stop prompting. Start building the machine that prompts for you.
          </p>
        </div>

        <div className="bg-dark-900 border-2 border-cyan-500/50 rounded-2xl p-6 md:p-8 text-center shadow-[0_0_50px_rgba(0,240,255,0.1)] relative overflow-hidden" data-id="element-297">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-400 to-blue-600" data-id="element-298"></div>

          <h3 className="text-2xl font-bold text-white mb-1" data-id="element-299">
            THE $10K AI CONTENT ENGINE
          </h3>
          <p className="text-gray-400 mb-5" data-id="element-300">
            (Includes The Full 30-Day Execution Sprint Plan)
          </p>

          {/* Bonuses Included */}
          <div className="text-left bg-dark-950 rounded-xl border border-cyan-900/30 p-5 mb-6" data-id="element-301">
            <p className="text-sm font-bold text-cyan-400 uppercase tracking-wider mb-3 text-center" data-id="element-302">
              Included Free — 3 Execution Bonuses
            </p>
            <div className="space-y-3" data-id="element-303">
              <div className="flex items-start gap-3" data-id="element-304">
                <div className="w-8 h-8 rounded-lg bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-305">
                  <TargetIcon className="w-4 h-4 text-cyan-400" data-id="element-306" />
                </div>
                <div data-id="element-307">
                  <p className="text-white font-bold text-sm" data-id="element-308">
                    30-Minute Offer Clarity Kit
                    <span className="ml-1.5 inline-block text-[9px] font-extrabold uppercase tracking-widest bg-cyan-400 text-black px-1.5 py-0.5 rounded align-middle" data-id="element-309">
                      FREE
                    </span>
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-310">
                    Build a $10K/mo retainer in one sitting
                  </p>
                </div>
                <span className="text-gray-600 text-xs line-through ml-auto shrink-0" data-id="element-311">
                  $197
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-312">
                <div className="w-8 h-8 rounded-lg bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-313">
                  <MessageSquareIcon className="w-4 h-4 text-cyan-400" data-id="element-314" />
                </div>
                <div data-id="element-315">
                  <p className="text-white font-bold text-sm" data-id="element-316">
                    Corporate-to-Creator Scripts
                    <span className="ml-1.5 inline-block text-[9px] font-extrabold uppercase tracking-widest bg-cyan-400 text-black px-1.5 py-0.5 rounded align-middle" data-id="element-317">
                      FREE
                    </span>
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-318">
                    DMs, calls & objection killers for $10K retainers
                  </p>
                </div>
                <span className="text-gray-600 text-xs line-through ml-auto shrink-0" data-id="element-319">
                  $297
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-320">
                <div className="w-8 h-8 rounded-lg bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-321">
                  <CalendarIcon className="w-4 h-4 text-cyan-400" data-id="element-322" />
                </div>
                <div data-id="element-323">
                  <p className="text-white font-bold text-sm" data-id="element-324">
                    4-Hours/Week Execution Planner
                    <span className="ml-1.5 inline-block text-[9px] font-extrabold uppercase tracking-widest bg-cyan-400 text-black px-1.5 py-0.5 rounded align-middle" data-id="element-325">
                      FREE
                    </span>
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-326">
                    Burnout-proof build schedule
                  </p>
                </div>
                <span className="text-gray-600 text-xs line-through ml-auto shrink-0" data-id="element-327">
                  $97
                </span>
              </div>
            </div>
            <div className="mt-3 pt-3 border-t border-cyan-900/30 flex justify-between items-center" data-id="element-328">
              <span className="text-gray-400 text-sm" data-id="element-329">Total bonus value</span>
              <span className="text-cyan-400 font-bold" data-id="element-330">$591 FREE</span>
            </div>
          </div>

          {/* ═══════════ ORDER BUMP #1 ═══════════ */}
          <div onClick={() => setBump1(!bump1)} className={`relative text-left rounded-xl border-2 p-4 mb-4 cursor-pointer transition-all duration-300 ${bump1 ? 'border-amber-400 bg-amber-500/10 shadow-[0_0_25px_rgba(245,158,11,0.2)]' : 'border-amber-500/40 bg-amber-950/20 hover:border-amber-400/60 hover:bg-amber-950/30'}`} data-id="element-331">
            {/* ONE-TIME OFFER tag */}
            <div className="absolute -top-3 right-4 bg-gradient-to-r from-amber-500 to-orange-500 text-black text-[10px] font-extrabold uppercase tracking-widest px-3 py-1 rounded-full shadow-lg" data-id="element-332">
              ONE-TIME OFFER
            </div>

            <div className="flex items-start gap-4" data-id="element-333">
              {/* Checkbox */}
              <div className={`mt-1 w-6 h-6 rounded border-2 flex items-center justify-center shrink-0 transition-all ${bump1 ? 'bg-cyan-400 border-cyan-400' : 'border-gray-600 bg-transparent'}`} data-id="element-334">
                {bump1 && <CheckIcon className="w-4 h-4 text-black" data-id="element-335" />}
              </div>

              <div className="flex-1 min-w-0" data-id="element-336">
                {/* Icon + Headline */}
                <div className="flex items-center gap-2 mb-2" data-id="element-337">
                  <ZapIcon className="w-5 h-5 text-amber-400 shrink-0" data-id="element-338" />
                  <h4 className="text-base md:text-lg font-bold text-white leading-tight" data-id="element-339">
                    The Zero-Draft Library
                  </h4>
                </div>

                {/* Image */}
                <div className="relative rounded-lg overflow-hidden border border-cyan-500/20 mb-3" data-id="element-340">
                  <img src="https://cdn.magicpatterns.com/uploads/r1MAsaFmjmmzvwC2a1Rqw7/order_bump_1_the_10_k.png" alt="The Zero-Draft Template Library" className="w-full h-auto" data-id="element-341" />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-900/50 via-transparent to-transparent pointer-events-none" data-id="element-342"></div>
                </div>

                <p className="text-sm text-gray-400 leading-relaxed mb-3" data-id="element-343">
                  Don't waste your weekend building a content system from
                  scratch. The Zero-Draft Template Library (PDF) gives you the
                  mental + technical architecture to go from raw ideas to
                  publish-ready drafts—fast.
                  <br data-id="element-344" />
                  <br data-id="element-345" />
                  Inside, you'll get the{' '}
                  <span className="text-cyan-400" data-id="element-346">
                    3-stage content pipeline
                  </span>{' '}
                  (Capture Vault → Processing Plant → Distribution Hub), the{' '}
                  <span className="text-cyan-400" data-id="element-347">Voice DNA Schema</span> to
                  make AI sound like you, a master prompt wrapper, proven hook
                  formulas, a 1-minute polish checklist, a 7-day high-exposure
                  calendar, and simple tracking rules—so you can flip the switch
                  on your content engine and start publishing today.
                </p>

                <div className="flex items-center justify-between" data-id="element-348">
                  <span className="text-cyan-400 font-bold text-lg" data-id="element-349">
                    Add to order — just $9
                  </span>
                  <span className="text-gray-600 text-sm line-through" data-id="element-350">
                    $97
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* ═══════════ ORDER BUMP #2 ═══════════ */}
          <div onClick={() => setBump2(!bump2)} className={`relative text-left rounded-xl border-2 p-4 mb-6 cursor-pointer transition-all duration-300 ${bump2 ? 'border-emerald-400 bg-emerald-500/10 shadow-[0_0_25px_rgba(16,185,129,0.2)]' : 'border-emerald-500/40 bg-emerald-950/20 hover:border-emerald-400/60 hover:bg-emerald-950/30'}`} data-id="element-351">
            {/* 90% OFF tag */}
            <div className="absolute -top-3 right-4 bg-gradient-to-r from-emerald-500 to-green-500 text-black text-[10px] font-extrabold uppercase tracking-widest px-3 py-1 rounded-full shadow-lg" data-id="element-352">
              90% OFF
            </div>

            <div className="flex items-start gap-4" data-id="element-353">
              {/* Checkbox */}
              <div className={`mt-1 w-6 h-6 rounded border-2 flex items-center justify-center shrink-0 transition-all ${bump2 ? 'bg-cyan-400 border-cyan-400' : 'border-gray-600 bg-transparent'}`} data-id="element-354">
                {bump2 && <CheckIcon className="w-4 h-4 text-black" data-id="element-355" />}
              </div>

              <div className="flex-1 min-w-0" data-id="element-356">
                {/* Icon + Headline */}
                <div className="flex items-center gap-2 mb-2" data-id="element-357">
                  <ShieldIcon className="w-5 h-5 text-emerald-400 shrink-0" data-id="element-358" />
                  <h4 className="text-base md:text-lg font-bold text-white leading-tight" data-id="element-359">
                    The Authority Shield: Close $2k-$5k Retainers with Certainty
                  </h4>
                </div>

                {/* Image */}
                <div className="relative rounded-lg overflow-hidden border border-cyan-500/20 mb-3" data-id="element-360">
                  <img src="https://cdn.magicpatterns.com/uploads/nD2Yvex6h5cnxbWnDyTK6x/ORDER_BUMP_2_THE_10K.png" alt="The High-Ticket Retainer Agreement" className="w-full h-auto" data-id="element-361" />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-900/50 via-transparent to-transparent pointer-events-none" data-id="element-362"></div>
                </div>

                <p className="text-sm text-gray-400 leading-relaxed mb-3" data-id="element-363">
                  Stop sending proposals that look like resumes and start
                  closing deals like a Systems Architect. This{' '}
                  <strong className="text-gray-200" data-id="element-364">
                    1-Page Service Agreement
                  </strong>{' '}
                  is designed to protect your time, eliminate infinite
                  revisions, and ensure recurring payments hit your account on
                  Day 1 of every month. Includes the{' '}
                  <span className="text-cyan-400" data-id="element-365">AI Efficiency Clause</span>{' '}
                  (to charge more for your speed) and the exact negotiation
                  script to get the signature without hesitation. Protect your
                  business and professionalize your income.
                </p>

                <div className="flex items-center justify-between" data-id="element-366">
                  <span className="text-cyan-400 font-bold text-lg" data-id="element-367">
                    Add to order — just $9
                  </span>
                  <span className="text-gray-600 text-sm line-through" data-id="element-368">
                    $97
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* ═══════════ DYNAMIC PRICE DISPLAY ═══════════ */}
          <div className="border-t-2 border-cyan-500/30 pt-5 mb-2" data-id="element-369">
            {/* Urgency line */}
            <p className="text-xs font-bold text-amber-400 uppercase tracking-widest text-center mb-2" data-id="element-370">
              Launch price — increases soon
            </p>

            {/* Order summary when bumps selected */}
            {(bump1 || bump2) && <div className="bg-dark-950 rounded-lg border border-cyan-900/30 p-4 mb-4 text-left" data-id="element-371">
                <p className="text-xs font-bold text-cyan-400 uppercase tracking-wider mb-2" data-id="element-372">
                  Your Order
                </p>
                <div className="space-y-2" data-id="element-373">
                  <div className="flex justify-between text-sm" data-id="element-374">
                    <span className="text-gray-300" data-id="element-375">
                      The $10K AI Content Engine
                    </span>
                    <span className="text-white font-medium" data-id="element-376">$27.00</span>
                  </div>
                  {bump1 && <div className="flex justify-between text-sm" data-id="element-377">
                      <span className="text-gray-300" data-id="element-378">
                        Zero-Draft Template Library
                      </span>
                      <span className="text-white font-medium" data-id="element-379">$9.00</span>
                    </div>}
                  {bump2 && <div className="flex justify-between text-sm" data-id="element-380">
                      <span className="text-gray-300" data-id="element-381">
                        High-Ticket Retainer Agreement
                      </span>
                      <span className="text-white font-medium" data-id="element-382">$9.00</span>
                    </div>}
                  <div className="border-t border-cyan-900/30 pt-2 mt-2 flex justify-between" data-id="element-383">
                    <span className="text-white font-bold" data-id="element-384">Total</span>
                    <span className="text-cyan-400 font-bold text-lg" data-id="element-385">
                      ${totalPrice.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>}

            <div className="text-5xl font-bold text-white mb-4 flex items-center justify-center gap-2" data-id="element-386">
              <span className="text-2xl text-gray-500 font-normal line-through" data-id="element-387">
                ${originalPrice}
              </span>
              <span className="text-cyan-400 text-glow" data-id="element-388">
                ${totalPrice.toFixed(2)}
              </span>
              <span className="text-lg text-gray-500 font-normal" data-id="element-389">
                One-Time Payment
              </span>
            </div>
          </div>

          {/* ═══════════ PURCHASE CTA ═══════════ */}
          <a href={getCartUrl()} target="_blank" rel="noopener noreferrer" onClick={handlePurchaseClick} className="w-full group relative inline-flex items-center justify-center px-8 py-5 font-bold text-black bg-gradient-to-r from-cyan-400 to-cyan-300 rounded-sm overflow-hidden transition-all hover:from-cyan-300 hover:to-cyan-200 hover:shadow-[0_0_40px_rgba(0,240,255,0.6)] mb-2" data-id="element-390">
            <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-full group-hover:h-56 opacity-10" data-id="element-391"></span>
            <span className="relative text-lg tracking-wide uppercase flex items-center gap-2" data-id="element-392">
              <ZapIcon className="w-5 h-5 fill-current" data-id="element-393" /> Get Instant Access —
              ${totalPrice.toFixed(2)}
            </span>
          </a>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-400 mt-2" data-id="element-394">
            <ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-395" />
            <span data-id="element-396">Secure Checkout • Instant Delivery</span>
          </div>

          {/* Guarantee Block */}
          <div className="bg-dark-950 border border-green-500/20 rounded-lg p-5 mt-6 text-center" data-id="element-397">
            <p className="text-sm text-gray-400 leading-relaxed" data-id="element-398">
              <span className="text-green-400 font-bold" data-id="element-399">
                30-Day Money-Back Guarantee
              </span>
              {' — '}
              If you don't have your offer defined, scripts ready, and system
              running, I'll refund every cent. No questions.
            </p>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-cyan-900/30" data-id="element-400">
          <p className="text-lg text-gray-300 mb-5" data-id="element-401">
            Welcome to the Ghost in the Machine.
            <br data-id="element-402" />
            <br data-id="element-403" />
            To your success,
            <br data-id="element-404" />
            <strong className="text-white text-[16px] font-[400]" data-id="element-405">
              The $10K AI Content Engine.
            </strong>
          </p>

          <div className="bg-dark-950 p-6 rounded-lg border border-cyan-900/20 text-gray-400 text-sm leading-relaxed" data-id="element-406">
            <strong className="text-cyan-400" data-id="element-407">P.S.</strong> In the US market,
            time is more valuable than money. High-ticket clients will pay you
            $2,500/month just to stop thinking about content. I'm showing you
            how to be the person they pay. Don't get left behind in the manual
            labor era. Enter the Architecture era today.
          </div>
        </div>

        <div className="mt-12 pt-10 border-t-2 border-cyan-900/50" data-id="element-408">
          <h3 className="text-2xl md:text-3xl font-bold text-white text-center mb-10 tracking-wide uppercase" data-id="element-409">
            Two versions of next Monday exist.
          </h3>

          <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-410">
            {/* Version A */}
            <div className="bg-dark-900 border border-gray-800 rounded-xl p-8 relative" data-id="element-411">
              <div className="absolute top-0 left-0 w-full h-1 bg-gray-700 rounded-t-xl" data-id="element-412"></div>
              <h4 className="text-xl font-bold text-gray-400 mb-6" data-id="element-413">
                Version A:
              </h4>
              <ul className="space-y-4 text-gray-500 text-lg" data-id="element-414">
                <li data-id="element-415">You open your laptop.</li>
                <li data-id="element-416">The same client is waiting.</li>
                <li data-id="element-417">The same content isn't written.</li>
                <li data-id="element-418">The same 60-hour week begins again.</li>
              </ul>
            </div>

            {/* Version B */}
            <div className="bg-cyan-950/20 border border-cyan-500/30 rounded-xl p-8 relative shadow-[0_0_30px_rgba(0,240,255,0.05)] box-glow" data-id="element-419">
              <div className="absolute top-0 left-0 w-full h-1 bg-cyan-400 rounded-t-xl" data-id="element-420"></div>
              <h4 className="text-xl font-bold text-cyan-400 mb-6" data-id="element-421">
                Version B:
              </h4>
              <ul className="space-y-4 text-gray-300 text-lg" data-id="element-422">
                <li data-id="element-423">You open your laptop.</li>
                <li data-id="element-424">The system ran overnight.</li>
                <li data-id="element-425">Three posts are drafted.</li>
                <li data-id="element-426">The retainer invoice went out automatically.</li>
                <li data-id="element-427">You have a 10am strategy call.</li>
                <li className="text-white font-medium pt-2" data-id="element-428">
                  That's it. That's the week.
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center max-w-2xl mx-auto" data-id="element-429">
            <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-430">
              The only difference between those two Mondays is a{' '}
              <strong className="text-cyan-400 text-glow" data-id="element-431">
                ${totalPrice.toFixed(2)} decision
              </strong>{' '}
              you make right now.
            </p>

            <a href={getCartUrl()} target="_blank" rel="noopener noreferrer" onClick={handlePurchaseClick} className="w-full md:w-auto group relative inline-flex items-center justify-center px-10 py-5 font-bold text-black bg-cyan-400 rounded-sm overflow-hidden transition-all hover:bg-cyan-300 hover:shadow-[0_0_40px_rgba(0,240,255,0.6)] mb-4" data-id="element-432">
              <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-full group-hover:h-56 opacity-10" data-id="element-433"></span>
              <span className="relative text-lg tracking-wide uppercase flex items-center gap-2" data-id="element-434">
                INITIALIZE THE ENGINE — ${totalPrice.toFixed(2)}{' '}
                <ArrowRightIcon className="w-5 h-5" data-id="element-435" />
              </span>
            </a>

            <div className="flex items-center justify-center gap-4 text-sm text-gray-400" data-id="element-436">
              <div className="flex items-center gap-1.5" data-id="element-437">
                <ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-438" />
                <span data-id="element-439">Instant Access</span>
              </div>
              <span className="text-gray-700" data-id="element-440">•</span>
              <div className="flex items-center gap-1.5" data-id="element-441">
                <CheckIcon className="w-4 h-4 text-cyan-400" data-id="element-442" />
                <span data-id="element-443">30-Day Guarantee</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}